import * as React from 'react';

const SvgCozinha = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        height="1em"
        viewBox="0 0 52 50"
        width="1em"
        fill="currentColor"
        className="svg-icon"
        {...props}
    >
        <path
            d="M32.625 23.75L28.75 27.625L47.125 46L43.375 49.75L25 31.375L6.625 49.75L2.875 46L28.875 20C27.875 18 27.7083 15.6667 28.375 13C29.125 10.3333 30.5417 7.95833 32.625 5.875C35.2083 3.29167 38.0833 1.83333 41.25 1.5C44.4167 1.08333 46.9583 1.83333 48.875 3.75C50.7917 5.66667 51.5417 8.25 51.125 11.5C50.7917 14.6667 49.3333 17.5417 46.75 20.125C44.6667 22.2083 42.2917 23.5833 39.625 24.25C36.9583 24.9167 34.625 24.75 32.625 23.75ZM14.625 28.625L3.375 17.375C1.29167 15.2917 0.25 12.7917 0.25 9.875C0.25 6.95833 1.29167 4.45833 3.375 2.375L22.125 21L14.625 28.625Z"
        />
    </svg>
);

export default SvgCozinha;
